import React, { useState } from 'react';
import { Moon, XIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
type ModalType = 'terms' | 'privacy' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-navy border-t border-white/10 py-12 text-center" data-id="element-26">
        <div className="max-w-4xl mx-auto px-6" data-id="element-27">
          <div className="flex justify-center mb-6" data-id="element-28">
            <Moon className="w-8 h-8 text-amber/50" data-id="element-29" />
          </div>
          <p className="text-cream/50 text-sm mb-4" data-id="element-30">
            © {new Date().getFullYear()} Dulces Sueños. Todos los derechos
            reservados.
          </p>
          <div className="flex justify-center gap-6 mb-4" data-id="element-31">
            <button onClick={() => setActiveModal('terms')} className="text-cream/50 hover:text-amber text-sm underline underline-offset-2 transition-colors" data-id="element-32">
              Términos y Condiciones
            </button>
            <button onClick={() => setActiveModal('privacy')} className="text-cream/50 hover:text-amber text-sm underline underline-offset-2 transition-colors" data-id="element-33">
              Política de Privacidad
            </button>
          </div>
          <p className="text-cream/30 text-xs max-w-2xl mx-auto" data-id="element-34">
            Este producto no sustituye el consejo médico profesional. Si tienes
            preocupaciones sobre la salud de tu bebé, consulta siempre a tu
            pediatra.
          </p>
        </div>
      </footer>

      <AnimatePresence data-id="element-35">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-navy/80 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-36">
            <motion.div initial={{
          opacity: 0,
          y: 20,
          scale: 0.97
        }} animate={{
          opacity: 1,
          y: 0,
          scale: 1
        }} exit={{
          opacity: 0,
          y: 20,
          scale: 0.97
        }} transition={{
          duration: 0.3
        }} className="bg-cream rounded-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-37">
              <div className="sticky top-0 bg-cream border-b border-navy/10 px-6 py-4 flex items-center justify-between rounded-t-2xl" data-id="element-38">
                <h3 className="text-xl font-serif text-navy" data-id="element-39">
                  {activeModal === 'terms' ? 'Términos y Condiciones' : 'Política de Privacidad'}
                </h3>
                <button onClick={() => setActiveModal(null)} className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-navy/10 transition-colors" data-id="element-40">
                  <XIcon className="w-5 h-5 text-navy" data-id="element-41" />
                </button>
              </div>

              <div className="px-6 py-6 text-navy/80 text-sm leading-relaxed space-y-4" data-id="element-42">
                {activeModal === 'terms' ? <TermsContent data-id="element-43" /> : <PrivacyContent data-id="element-44" />}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}
function TermsContent() {
  return <>
      <p className="text-xs text-navy/50" data-id="element-45">Última actualización: abril 2026</p>

      <h4 className="font-serif text-lg text-navy mt-4" data-id="element-46">
        1. Información General
      </h4>
      <p data-id="element-47">
        Al adquirir el producto digital "Dulces Sueños" (en adelante, "el
        Producto"), aceptas los presentes Términos y Condiciones. El Producto es
        ofrecido por Estado Vittal a través de su plataforma en línea.
      </p>

      <h4 className="font-serif text-lg text-navy" data-id="element-48">
        2. Naturaleza del Producto
      </h4>
      <p data-id="element-49">
        El Producto es una guía digital descargable que contiene información
        educativa sobre el sueño infantil. No constituye asesoría médica,
        psicológica ni profesional de ningún tipo. Siempre consulta a tu
        pediatra ante cualquier duda sobre la salud de tu bebé.
      </p>

      <h4 className="font-serif text-lg text-navy" data-id="element-50">3. Entrega y Acceso</h4>
      <p data-id="element-51">
        El acceso al Producto es inmediato tras la confirmación del pago.
        Recibirás un enlace de descarga por correo electrónico. Es tu
        responsabilidad proporcionar una dirección de correo válida.
      </p>

      <h4 className="font-serif text-lg text-navy" data-id="element-52">4. Política de Reembolso</h4>
      <p data-id="element-53">
        Debido a la naturaleza digital del Producto, no se aceptan devoluciones
        ni reembolsos una vez realizada la descarga. Si experimentas problemas
        técnicos para acceder al contenido, contáctanos y te ayudaremos a
        resolverlo.
      </p>

      <h4 className="font-serif text-lg text-navy" data-id="element-54">5. Propiedad Intelectual</h4>
      <p data-id="element-55">
        Todo el contenido del Producto está protegido por derechos de autor.
        Queda prohibida su reproducción, distribución, modificación o reventa
        total o parcial sin autorización expresa por escrito.
      </p>

      <h4 className="font-serif text-lg text-navy" data-id="element-56">
        6. Limitación de Responsabilidad
      </h4>
      <p data-id="element-57">
        Los resultados pueden variar según cada bebé y familia. No garantizamos
        resultados específicos. El uso del Producto es bajo tu propia
        responsabilidad.
      </p>

      <h4 className="font-serif text-lg text-navy" data-id="element-58">7. Modificaciones</h4>
      <p data-id="element-59">
        Nos reservamos el derecho de modificar estos Términos y Condiciones en
        cualquier momento. Las modificaciones serán efectivas desde su
        publicación en el sitio web.
      </p>

      <h4 className="font-serif text-lg text-navy" data-id="element-60">8. Contacto</h4>
      <p data-id="element-61">
        Para cualquier consulta relacionada con estos términos, puedes
        escribirnos a través de nuestro sitio web estadovittal.com.
      </p>
    </>;
}
function PrivacyContent() {
  return <>
      <p className="text-xs text-navy/50" data-id="element-62">Última actualización: abril 2026</p>

      <h4 className="font-serif text-lg text-navy mt-4" data-id="element-63">
        1. Responsable del Tratamiento
      </h4>
      <p data-id="element-64">
        Estado Vittal es responsable del tratamiento de los datos personales
        recopilados a través de esta página y del proceso de compra del producto
        "Dulces Sueños".
      </p>

      <h4 className="font-serif text-lg text-navy" data-id="element-65">2. Datos que Recopilamos</h4>
      <p data-id="element-66">
        Recopilamos únicamente los datos necesarios para procesar tu compra:
      </p>
      <ul className="list-disc pl-5 space-y-1" data-id="element-67">
        <li data-id="element-68">Nombre completo</li>
        <li data-id="element-69">Dirección de correo electrónico</li>
        <li data-id="element-70">
          Información de pago (procesada de forma segura por nuestro proveedor
          de pagos)
        </li>
      </ul>

      <h4 className="font-serif text-lg text-navy" data-id="element-71">
        3. Finalidad del Tratamiento
      </h4>
      <p data-id="element-72">Tus datos se utilizan exclusivamente para:</p>
      <ul className="list-disc pl-5 space-y-1" data-id="element-73">
        <li data-id="element-74">Procesar y entregar tu compra</li>
        <li data-id="element-75">Enviarte el enlace de descarga del Producto</li>
        <li data-id="element-76">Comunicarnos contigo en caso de incidencias con tu pedido</li>
        <li data-id="element-77">
          Enviarte información relacionada con el Producto (solo si das tu
          consentimiento)
        </li>
      </ul>

      <h4 className="font-serif text-lg text-navy" data-id="element-78">
        4. Seguridad de los Datos
      </h4>
      <p data-id="element-79">
        Implementamos medidas de seguridad técnicas y organizativas para
        proteger tus datos personales contra acceso no autorizado, pérdida o
        alteración. Los pagos se procesan a través de plataformas seguras con
        encriptación SSL.
      </p>

      <h4 className="font-serif text-lg text-navy" data-id="element-80">5. Compartición de Datos</h4>
      <p data-id="element-81">
        No vendemos, alquilamos ni compartimos tus datos personales con
        terceros, excepto con los proveedores de servicios necesarios para
        procesar tu compra (plataforma de pago y servicio de correo
        electrónico).
      </p>

      <h4 className="font-serif text-lg text-navy" data-id="element-82">6. Tus Derechos</h4>
      <p data-id="element-83">Tienes derecho a:</p>
      <ul className="list-disc pl-5 space-y-1" data-id="element-84">
        <li data-id="element-85">Acceder a tus datos personales</li>
        <li data-id="element-86">Solicitar la rectificación de datos inexactos</li>
        <li data-id="element-87">Solicitar la eliminación de tus datos</li>
        <li data-id="element-88">Retirar tu consentimiento en cualquier momento</li>
      </ul>

      <h4 className="font-serif text-lg text-navy" data-id="element-89">7. Cookies</h4>
      <p data-id="element-90">
        Esta página puede utilizar cookies para mejorar la experiencia del
        usuario y con fines analíticos. Puedes configurar tu navegador para
        rechazar cookies, aunque esto podría afectar la funcionalidad del sitio.
      </p>

      <h4 className="font-serif text-lg text-navy" data-id="element-91">8. Contacto</h4>
      <p data-id="element-92">
        Para ejercer tus derechos o realizar consultas sobre tu privacidad,
        puedes contactarnos a través de nuestro sitio web estadovittal.com.
      </p>
    </>;
}